// import RestaurantsList from '@/screens/restaurants/List'
import RestaurantDetails from '@/screens/restaurants/Details'
import RestaurantAreas from '@/screens/restaurants/areas/List'
import RestaurantSections from '@/screens/restaurants/sections/List'
import RestaurantUsers from '@/screens/restaurants/users/List'
import RestaurantProviders from '@/screens/restaurants/providers/List'
import RestaurantBalance from '@/screens/restaurants/balance'
import RestaurantPointSale from '@/screens/settings/PointSale'
import RestaurantReports from '@/screens/restaurants/reports'
import RestaurantReportsSalesAndCosts from '@/screens/restaurants/reports/SalesAndCosts'
import RestaurantReportsPriceComparison from '@/screens/restaurants/reports/PriceComparison.vue'
import RestaurantReportsProviderPriceComparison from '@/screens/restaurants/reports/ProviderPriceComparison.vue'
import RestaurantReportsPurchasesTracking from '@/screens/restaurants/reports/PurchasesTracking.vue'
import RestaurantReportsRecipesTracking from '@/screens/restaurants/reports/RecipesTracking.vue'
import RestaurantReportsConsumption from '@/screens/restaurants/reports/Consumption.vue'

import RestaurantFinances from '@/screens/settings/finances'
import IncomeCategories from '@/screens/settings/finances/IncomeCategories'
import PaymentMethods from '@/screens/settings/finances/PaymentMethods'
import OutgoingCategories from '@/screens/settings/finances/OutgoingCategories'
import Accounts from '@/screens/settings/finances/Accounts'
import auth from './middleware/auth'
import store from '@/store'

const routes = [
  // {
  //   path: '/restaurants',
  //   name: 'Restaurants',
  //   component: RestaurantsList,
  //   meta: {
  //     requireAuth: true,
  //     permissions: ['manager'],
  //     middleware: { auth }
  //   }
  // },
  {
    path: '/restaurants/:id',
    name: 'RestaurantDetails',
    component: RestaurantDetails,
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/areas',
    name: 'RestaurantAreas',
    component: RestaurantAreas,
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  }, {
    path: '/point-sale',
    name: 'RestaurantPointSale',
    component: RestaurantPointSale,
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/sections',
    name: 'RestaurantSections',
    component: RestaurantSections,
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/users',
    name: 'RestaurantUsers',
    component: RestaurantUsers,
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/providers-allowed',
    name: 'RestaurantProviders',
    component: RestaurantProviders,
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/finances',
    name: 'Finances',
    component: {
      ...RestaurantFinances,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'Finances') {
          const routes = {
            manager: 'IncomeCategories'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'Finances') {
          const routes = {
            manager: 'IncomeCategories'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: { requireAuth: true },
    children: [
      {
        name: 'IncomeCategories',
        path: '/income-categories',
        component: IncomeCategories,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        name: 'PaymentMethods',
        path: '/payment-methods',
        component: PaymentMethods,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        name: 'OutgoingCategories',
        path: '/outgoing-categories',
        component: OutgoingCategories,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        name: 'Accounts',
        path: '/accounts',
        component: Accounts,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      }
    ]
  },
  {
    path: '/manage-balance',
    name: 'RestaurantBalance',
    component: RestaurantBalance,
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/reports',
    name: 'RestaurantReports',
    component: {
      ...RestaurantReports,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'RestaurantReports') {
          const routes = {
            manager: 'SalesAndCosts'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'RestaurantReports') {
          const routes = {
            manager: 'SalesAndCosts'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'sales-and-costs',
        name: 'SalesAndCosts',
        component: RestaurantReportsSalesAndCosts,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'price-comparison',
        name: 'PriceComparison',
        component: RestaurantReportsPriceComparison,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'provider-price-comparison',
        name: 'ProviderPriceComparison',
        component: RestaurantReportsProviderPriceComparison,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'purchases-tracking',
        name: 'PurchasesTracking',
        component: RestaurantReportsPurchasesTracking,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'recipes-tracking',
        name: 'RecipesTracking',
        component: RestaurantReportsRecipesTracking,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'consumption',
        name: 'Consumption',
        component: RestaurantReportsConsumption,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      }
    ]
  }
]

export default routes
